<!-- 教育局-机构管理 -->
<template>
  <div>
    <div class="index">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>
      <div v-loading="loading">
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-select
              style="width: 200px"
              v-model="queryParams.semester"
              clearable
              placeholder="请选择学期"
              class="label"
              @change="searchFun"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.endDay"
                :label="item.schooleYearName"
                :value="item.schooleYearName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              style="width: 150px"
              v-model="queryParams.period"
              clearable
              placeholder="请选择学段"
              class="label"
              @change="handleChange"
            >
              <el-option
                v-for="item in periodlList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="请输入学校名称"
              v-model="queryParams.school_name"
              clearable
              @clear="searchFun"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px; float: right">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
            <el-button type="primary" size="small" @click="exportExcel()"
              >导出</el-button
            >
          </el-form-item>
        </el-form>
        <p style="margin: 0 0 2% 0; color: #909399">
          说明：年级下所有行政班均完成排课，则认为该年级已完成排课
        </p>
        <!-- 待审核 -->
        <div class="class-table">
          <template v-if="tableData && Object.keys(tableData).length">
            <table  id='exportOutTable' border='1'>
              <thead style="background: #f7f7f7">
                <tr>
                  <th rowspan="2" style="width: 14%">学校名称</th>
                  <th :colspan="gradeList.length" style="width: 46%">
                    作业辅导答疑课是否完成排课
                  </th>
                  <th
                    :colspan="
                      gradeList.length < 6
                        ? gradeList.length
                        : gradeList.length - 3
                    "
                    style="width: 33%"
                  >
                    校内活动课是否完成排课
                  </th>
                  <th rowspan="2" style="width: 7%">报名学生数</th>
                </tr>
                <tr>
                  <th
                    v-for="(it, i) in gradeList"
                    :key="i + Math.random()"
                    style="width: 42px; font-size: 12px"
                  >
                    {{ it.label }}
                  </th>
                  <th
                    v-for="(it, i) in gradeList"
                    v-if="
                      it.label != '七年级' &&
                      it.label != '八年级' &&
                      it.label != '九年级'
                    "
                    :key="i + Math.random()"
                    style="width: 42px; font-size: 12px"
                  >
                    {{ it.label }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(it, i) in tableData" :key="i + Math.random()">
                  <td>{{ it.schoolName }}</td>
                  <td v-for="(Q, i) in it.list" :key="i + Math.random()">
                    {{ Q.hw_std }}
                  </td>
                  <td
                    v-for="(K, i) in it.list"
                    v-if="
                      K.grade_name != '七年级' &&
                      K.grade_name != '八年级' &&
                      K.grade_name != '九年级'
                    "
                    :key="i + Math.random()"
                  >
                    {{ K.act_std }}
                  </td>
                  <td>{{ it.stuTotal }}</td>
                </tr>
              </tbody>
            </table>
          </template>
          <template  v-if="noData">
            <img class="no_data" src="@/assets/img/no_data.svg" alt="" />
          </template>
        </div>
        <div class="pagination">
          <el-pagination
            background
            :current-page="page.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            :total="page.totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  handleRosterStatistics,
  handleStatistics,
} from "@/api/education/homeApi.js";
import api from "@/api/schoolApi/index.js";
import util from "@/utils/util.js";
export default {
  components: {
    //  Information: () => import("./information.vue"),
  },
  data() {
    return {
      queryParams: {
        school_name: "",
        period: "xx",
        semester: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      loading: false,
      noData: false,
      gradeList: [
        { id: "0", label: "一年级" },
        { id: "1", label: "二年级" },
        { id: "2", label: "三年级" },
        { id: "3", label: "四年级" },
        { id: "5", label: "五年级" },
        { id: "6", label: "六年级" },
        { id: "7", label: "七年级" },
        { id: "8", label: "八年级" },
        { id: "9", label: "九年级" },
      ],
      periodlList: [
        { id: "xx", label: "小学" },
        { id: "cz", label: "初中" },
        { id: "gz", label: "高中" },
        // { id: "3", label: "完中" },
        // { id: "5", label: "教学点" },
        // { id: "6", label: "九年一贯制" },
        // { id: "7", label: "十二年一贯制" },
        // { id: "8", label: "高等教育" },
        // { id: "9", label: "其它教育类学校" },
        // { id: "10", label: "中职" },
        // { id: "11", label: "高职" },
        // { id: "12", label: "学前教育" },
      ],
      semesterList: [],
      tableData: [],
      Userlist: JSON.parse(window.sessionStorage.getItem("Userlist")),
    };
  },
  watch: {},
  mounted() {},
  created() {
    this.getStatisticalSemester();
    this.getNowSemester();
    this.getDataList();
  },
  filters: {
    recordStatusFilter(type) {
      const typeMap = {
        0: "未备案",
        1: "已备案",
      };
      return typeMap[type] || "未备案";
    },
  },
  methods: {
    async getDataList(grade) {
      this.tableData = [];
      try {
        this.loading = true;
        let eduType = sessionStorage.getItem("educationType");
        let params = {
          end_date: util.getNowDateRung(), //统计日期
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_id: this.queryParams.period,
          yearly_semester: this.queryParams.semester, //	学年学期		否
          topic: eduType == "province" ? "省" : eduType == "city" ? "市" : "区",
          orga_name: this.queryParams.school_name,
          pagenum: this.page.pageNum,
          pagesize: this.page.pageSize,
        };
        let { code, data } = await handleRosterStatistics(params);
        if (code === "0") {
          this.page.totalPage = data.total;
          if (data.rows && data.rows.length != 0) {
            data.rows.forEach((it) => {
              handleStatistics({ orga_id: it.orga_id }).then((res) => {
                if (res.code == "0") {
                  let gradeList;
                  if (grade == "gz") {
                    gradeList = [
                      {
                        grade_name: "高中一年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "高中二年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "高中三年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                    ];
                  } else {
                    gradeList = [
                      {
                        grade_name: "一年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "二年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "三年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "四年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "五年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "六年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "七年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "八年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                      {
                        grade_name: "九年级",
                        act_std: "-",
                        hw_std: "-",
                      },
                    ];
                  }

                  let stuTotal = 0;
                  res.data.rows.forEach((j) => {
                    stuTotal += j.stu_num;
                    j.index = parseInt(j.grade_id);
                    gradeList[j.index - 1].act_std = j.act_std;
                    gradeList[j.index - 1].hw_std = j.hw_std;
                  });

                  let item = {
                    schoolName: it.orga_name,
                    stuTotal: stuTotal,
                    list: gradeList,
                  };
                  this.tableData.push(item);
                }
              });
            });
            this.noData=false
            console.log("---------tableData", this.tableData);
          } else {
            this.tableData = [];
            this.noData=true
          }
          
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    exportExcel() {
      let vm = this;
      // let html = document.getElementById("exportOutTable")?.outerHTML.replace(/<(\w+) (.+?)>/g, (m, p1) => `<${p1}>`)
      // .replace('<table>', '<table border>');
       let html = document.getElementById("exportOutTable")?.outerHTML;
      // vnd.ms-excel.numberformat:@; 格式化文本
      // xmlns 和 head 中 用于显示网格线
       let excelHtml = `<html xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head>
          <xml>
            <x:ExcelWorkbook>
              <x:ExcelWorksheets>
                <x:ExcelWorksheet>
                  <x:WorksheetOptions>
                    <x:Print><x:ValidPrinterInfo /></x:Print>
                  </x:WorksheetOptions>
                </x:ExcelWorksheet>
              </x:ExcelWorksheets>
            </x:ExcelWorkbook>
          </xml>
        </head>
        <style>
          table{vnd.ms-excel.numberformat:@;width:1200px;}
            #exportOutTable {
              width:1200px;
              tr td {
              width:50px;
              text-align: center;
              font-weight: 400;
              border: 1px solid #ddd;
              padding: 8px 0;
            }
            }
          }
        </style>
          ${html}
        </html>`
      let excelBlob  = new Blob([excelHtml], {
        type: "application/vnd.ms-excel",
      });
      let excelTitle = `${vm.queryParams.semester}-${
        vm.queryParams.period == "xx"
          ? "小学学段"
          : vm.queryParams.period == "cz"
          ? "初中学段"
          : "高中学段"
      }-学校排课统计表.xlsx`;
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(excelBlob , "表格名称.xlsx");
      } else {
        let a = document.createElement("a");
        let url = window.URL.createObjectURL(excelBlob);
        //  var uri = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(html)
        a.href = url;
        a.download = excelTitle;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    },
    handleChange(val) {
      this.page.pageNum = 1;
      if (val == "gz") {
        this.gradeList = [
          { id: "10", label: "高中一年级" },
          { id: "11", label: "高中二年级" },
          { id: "12", label: "高中三年级" },
        ];
        this.getDataList("gz");
      } else {
        this.gradeList = [
          { id: "0", label: "一年级" },
          { id: "1", label: "二年级" },
          { id: "2", label: "三年级" },
          { id: "3", label: "四年级" },
          { id: "5", label: "五年级" },
          { id: "6", label: "六年级" },
          { id: "7", label: "七年级" },
          { id: "8", label: "八年级" },
          { id: "9", label: "九年级" },
        ];
        this.getDataList();
      }
    },
    async getNowSemester() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      if (month >= 9) {
        this.queryParams.semester = year + "-" + (year + 1) + "学年上学期";
      } else {
        this.queryParams.semester = year - 1 + "-" + year + "学年下学期";
      }
    },
    async getStatisticalSemester() {
      // 获取学期学年
      let params = {};
      let res = await api.schoolStatisticalSemester(params);
      if (res.result === "000000") {
        this.semesterList = res.data || [];
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.page.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.page.pageNum = val;
      this.getDataList();
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }
  .class-table {
    display: flex;
    justify-content: center;
    table,
    table tr th,
    table tr td {
      font-weight: 400;
      border: 1px solid #ddd;
      padding: 8px 0;
    }
    table {
      width: 100%;
      height: 100%;
      overflow: auto;
      min-height: 25px;
      line-height: 25px;
      text-align: center;
      border-collapse: collapse;
    }
    .no_data {
      margin: 100px 0;
    }
  }
  ::v-deep .el-form .el-input__inner {
    // width: 250px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.confirm {
  .content {
    width: 100%;
    padding: 0 15px 15px;
    text-align: center;
  }
}
</style>
